// See also Mueller.Business.Models.Appraisal.CompGrid.CompGridFormCodes

export const CompGridFormCodes = {
  RAPID_APPRAISAL_COMPARBLES: "RapidAppraisalComparables",
  URAR_1004_APPRAISALCOMPARABLES: "URAR_1004_APPRAISALCOMPARABLES",
  FNMA_APPRAISAL_COMPARABLE: "FNMA_Appraisal_Comparable",
  COLLATERAL_APPRAISAL_COMPARABLES: "CollateralAppraisalComparables",
  BBT_COMPARABLES_GRID_MUELLER_ENTERPRISE: "BBT_COMPARABLES_GRID_MUELLER_ENTERPRISE",
  REOMIT_APPRAISAL_COMPARABLES: "REOMIT_APPRAISAL_COMPARABLES",
  CHASE_SERVICING_COMPARABLES: "CHASE_SERVICING_COMPARABLES",
  COMPARABLES_GRID_MUELLER_ENTERPRISE: "COMPARABLES_GRID_MUELLER_ENTERPRISE",
};